"use strict";
exports.__esModule = true;
exports.manyOf = void 0;
var glossary_1 = require("../glossary");
function manyOf(modelName, options) {
    return {
        kind: glossary_1.RelationKind.ManyOf,
        modelName: modelName,
        unique: !!(options === null || options === void 0 ? void 0 : options.unique)
    };
}
exports.manyOf = manyOf;
